/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import adminReducer from "./adminSlice";
import sidebarReducer from "./sidebarSlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    admin: adminReducer,
    sidebar: sidebarReducer,
  },
});

window.__REDUX_STORE__ = store;
